module.exports = __webpack_public_path__ + "static/ProServices-Photo1-c78c3f4299765c2ba9dd531529e11f02.png";